import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/login/login'
import Home from '@/pages/home/home'
import usercenter from '@/pages/home/usercenter'
import AreaTotle from '@/pages/home/AreaTotle'
import MonitorList from '@/pages/home/MonitorList'
import MonitorDetail from '@/pages/home/MonitorDetail'
import WarnMonitorDetail from '@/pages/home/WarnMonitorDetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: Login,
      meta: {
        title: '登陆',
        noshowback: true,
        nobottombar: true,
      },
    },
    {
      path: '/areatotle/:AreaID',
      name: 'areatotle',
      component: AreaTotle,
      meta: {
        title: '区域数据汇总',

      },
    },
    {
      path: '/monitorlist/:AreaID/:StoreID/:Status',
      name: 'monitorlist',
      component: MonitorList,
      meta: {
        title: '设备列表',

      },
    },
    {
      path: '/monitordetail/:MonitorID',
      name: 'monitordetail',
      component: MonitorDetail,
      meta: {
        title: '设备详情',

      },
    },
    {
      path: '/warnmonitordetail/:MonitorID/:openid',
      name: 'warnmonitordetail',
      component: WarnMonitorDetail,
      meta: {
        title: '设备详情',
        noshowback: true,
        nobottombar: true,
      },
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        title: '区域选择',

      },
    },
    {
      path: '/usercenter',
      name: 'usercenter',
      component: usercenter,
      meta: {
        title: '个人中心',

      },
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js